import { Check, CircleAlert } from "lucide-react";
import { isGenerating, type ProductStatus } from "@/content/schema";
import { fr } from "@/i18n/fr";

interface StatusBadgeProps {
	status: ProductStatus;
}

const TONES: Partial<Record<ProductStatus, string>> = {
	ready: "bg-ok-soft text-ok",
	failed: "bg-danger-soft text-danger",
};

/** Generation status of a product, as a small pill that always carries a word (and an icon). */
export function StatusBadge({ status }: StatusBadgeProps) {
	const running = isGenerating(status);
	const tone =
		TONES[status] ??
		(running ? "bg-accent-soft text-accent" : "bg-chip text-fg-muted");
	return (
		<span
			className={`inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-pill px-2 py-0.5 font-medium text-xs ${tone}`}
		>
			{running && (
				<span
					aria-hidden="true"
					className="size-1.5 animate-pulse rounded-full bg-current motion-reduce:animate-none"
				/>
			)}
			{status === "ready" && (
				<Check className="size-3.5" strokeWidth={2.25} aria-hidden="true" />
			)}
			{status === "failed" && (
				<CircleAlert className="size-3.5" aria-hidden="true" />
			)}
			{fr.generationStatus[status]}
		</span>
	);
}
